module.exports = __webpack_public_path__ + "static/media/android.49a8d90a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/android.png
// module id = 131
// module chunks = 0